var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-text-field',_vm._b({attrs:{"rules":_vm.timeLabelRules},model:{value:(_vm.timeValue),callback:function ($$v) {_vm.timeValue=$$v},expression:"timeValue"}},'v-text-field',_vm.otherProps,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }